import { render, staticRenderFns } from "./ComponentsPage.vue?vue&type=template&id=07cddc4b&"
import script from "./ComponentsPage.vue?vue&type=script&lang=ts&"
export * from "./ComponentsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports